import React, {useCallback, useEffect, useState} from 'react';
import "./debug-popup.scss"
import AssetsUploadInput from "../input/assets-upload-input";
import {useAppSelector} from "../../redux/store";
import * as cnfStorage from '../../redux/storages/configuration-storage'
import {viewerService} from "../../services/viewer-service";

interface IProps {}

let hdrConfiguratorUrl: any = undefined

const AssetsUploadHdrConfigurator: React.FC<IProps> = () => {
    const conf = useAppSelector(cnfStorage.selectors.getConfiguration);
    const [assetUrl, setAssetUrl] = useState<any>(hdrConfiguratorUrl)

    useEffect(() => {
            return () => {
                hdrConfiguratorUrl = assetUrl;
            };
        }, [assetUrl]
    )

    const onUpload = useCallback(async (file: File) => {
        setAssetUrl(file.name)
        if (undefined === conf) {

            return;
        }
        const url = URL.createObjectURL(file);
        await viewerService.reinit({}, {
            viewer: {
                hdrUrl: url,
            }
        })
        viewerService.showConfiguration(conf);
    },[conf])

    return (
        <AssetsUploadInput
            onUpload={onUpload}
            name={"hdr configurator"}
            fileName={assetUrl}
        />
    );
}

export default AssetsUploadHdrConfigurator